// @ts-ignore
/* eslint-disable */
import request from '../../utils/request';

/** 获取投顾老师详情 # **获取AccessToken** 
<a href='http://auth-service-beta2.shrise.cn/doc.html#/default/token-controller/generateUserAccessTokenUsingPOST' target='_blank'>点击此处获取测试站用户AccessToken</a>参数示例: 
  ```
{
  "productType": 171,
  "userId": 240
}
  ```
 GET /analyst */
export async function analystUsingGET(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.analystUsingGETParams,
  options?: { [key: string]: any },
) {
  return request<API.BaseResultSsAnalystInfo>('/analyst', {
    method: 'GET',
    params: {
      ...params,
    },
    ...(options || {}),
  });
}

/** 获取案例频道对应老师 # **获取AccessToken** 
<a href='http://auth-service-beta2.shrise.cn/doc.html#/default/token-controller/generateUserAccessTokenUsingPOST' target='_blank'>点击此处获取测试站用户AccessToken</a>参数示例: 
  ```
{
  "productType": 171,
  "userId": 240
}
  ```
 GET /analyst/getChannelAnalystList */
export async function analystGetChannelAnalystListUsingGET(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.analystGetChannelAnalystListUsingGETParams,
  options?: { [key: string]: any },
) {
  return request<API.BaseResultListAnalystInfoResp>('/analyst/getChannelAnalystList', {
    method: 'GET',
    params: {
      ...params,
    },
    ...(options || {}),
  });
}

/** 获取投顾老师列表 # **获取AccessToken** 
<a href='http://auth-service-beta2.shrise.cn/doc.html#/default/token-controller/generateUserAccessTokenUsingPOST' target='_blank'>点击此处获取测试站用户AccessToken</a>参数示例: 
  ```
{
  "productType": 171,
  "userId": 240
}
  ```
 GET /analyst/list */
export async function analystListUsingGET(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.analystListUsingGETParams,
  options?: { [key: string]: any },
) {
  return request<API.PageResultListSsAnalystInfo>('/analyst/list', {
    method: 'GET',
    params: {
      ...params,
    },
    ...(options || {}),
  });
}
